import clsx from 'clsx';
import { object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Card, Icon } from 'components';
import { formatLocalizedCurrency, getTravelOption } from 'helpers';
import { useUser } from 'hooks';
import { routes } from 'router';
import { appService } from 'services';

const TravelSummary = ({ travel }) => {
  const { t } = useTranslation();
  const isTouloisirsTravel = travel?.tourOperator === 'Touloisirs';
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const { currentUser } = useUser();
  const navigate = useNavigate();

  const handleBookingClick = () => {
    navigate({
      pathname: routes.travelPurchase.children.selection.path,
      search: createSearchParams({ travelId: id, typeItem: searchParams.get('typeItem') }).toString()
    });
  };

  return (
    <Card onMobile={false} onTablet={false} className="travel-summary">
      <div className="hidden lg:block print:block">
        <p className="uppercase font-semibold">{t('yourTravel')}</p>

        {travel?.options?.map((option, i) => {
          const travelOption = getTravelOption(option);
          return (
            <div key={`travel-option-${i}`} className={clsx(!!travelOption.icon && 'flex pt-4')}>
              {!!travelOption.icon && (
                <Icon name={travelOption.icon} iconStyle="fad" classes="w-6 h-6 text-yellow-500 mr-4" />
              )}
              <p>{t(travelOption?.i18n?.key, travelOption?.i18n?.data)}</p>
            </div>
          );
        })}

        <div className="flex justify-between my-4 border-t-2 border-solid pt-4">
          <p>{t('fromPrice')}</p>
          <p>
            <span className="text-lg font-bold">
              {formatLocalizedCurrency(isTouloisirsTravel ? travel.priceNotC2C : travel.price)}
            </span>
          </p>
        </div>
      </div>

      {searchParams.get('typeItem') !== 'CACHESPEED' && (
        <div className="flex justify-center print:hidden">
          {/* Travel purchase page is accessible only for Arrivaj */}
          {appService.isArrivaj() && (
            <button onClick={handleBookingClick} className="w-fit btn small lg:text-base">
              {t('booking')}
            </button>
          )}

          {appService.isTouloisirs() && (
            <a
              href={`${process.env.REACT_APP_CASTELIS_TUNNEL_URL}/VoyageCommand?id=${id}&typeItem=${searchParams.get(
                'typeItem'
              )}&token=${currentUser.token}`}
              className="w-fit btn small lg:text-base"
            >
              {t('booking')}
            </a>
          )}
        </div>
      )}
    </Card>
  );
};

TravelSummary.propTypes = {
  travel: object.isRequired
};

export default TravelSummary;
